import React, { useContext, useReducer } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import NotificationContext from '../../Notifications/NotificationContext';
import { initialState, reducer } from './topBarNotificationReducer';
import LastNotifications from '../../Notifications/LastNotifications';
import UIKitIcon from '../../../shared/UIKITComponents/Icon';
import { colors } from '../../../shared/theme';

const TopBarNotification: React.FC = () => {
  const { data } = useContext(NotificationContext);
  const [{ showNotificationPopover }, dispatch] = useReducer(reducer, initialState);
  const { list: lastNotifications, unreadItems: unReadNotifications } = data;

  const goToNotifications = async () => {
    if (showNotificationPopover) {
      dispatch({ type: 'SHOW', value: false });
      return;
    }
    dispatch({
      type: 'SHOW_POPOVER_AND_SET_DATA',
      showNotificationPopover: true,
      popoverNotifications: lastNotifications,
    });
  };
  const toggleNotificationPopover = () => dispatch({ type: 'SHOW', value: false });

  return (
    <div className="topbar__notifications">
      <button
        type="button"
        className="topbar__notifications__icon"
        onClick={goToNotifications}
        id="NotificationPopover"
      >
        {unReadNotifications > 0 && (
          <div className="topbar__notifications__icon--total">
            <span>{unReadNotifications}</span>
          </div>
        )}
        <UIKitIcon
          style={{ color: colors.specialColors.white }}
          name="notifications"
          variant="outlined"
        />
      </button>

      <Popover
        placement="bottom"
        isOpen={showNotificationPopover}
        target="NotificationPopover"
        trigger="legacy"
        toggle={toggleNotificationPopover}
        className="notifications"
      >
        <PopoverBody>
          <LastNotifications dispatch={dispatch} />
        </PopoverBody>
      </Popover>
    </div>
  );
};

export default TopBarNotification;
